import React, { useEffect, useMemo, useState } from 'react'
import Select from 'react-select';
import { BuildTalents, getDefaultName } from '../utils'
import { loadTalents } from '../utils/Network'
import { makeDarkSelectStyles } from './selectStyles';

function talentParentToId(v) {
    if (v == null || v === '') return null;
    if (typeof v === 'object' && v !== null && v.id != null) return v.id;
    const n = Number(v);
    return Number.isNaN(n) ? v : n;
}

export default function SelectAllTalents({ callback, value, width }) {

    const [SelectOptions, setSelectOptions] = useState([]);

    const customStyles = makeDarkSelectStyles({ width: width || '200px', marginBottom: '10px' });

    const valueId = useMemo(() => talentParentToId(value), [value]);

    const selectedOption = useMemo(() => {
        if (valueId == null || valueId === '' || !SelectOptions.length) return null;
        return SelectOptions.find((o) => o.value == valueId) ?? null;
    }, [SelectOptions, valueId]);

    function appendTalentOptions(item, temp_options, depth) {
        const name = getDefaultName(item.names)
        const label =
            depth === 0
                ? name
                : `${'   ' + '»'.repeat(Math.min(depth, 4))} ${name}`
        temp_options.push({ label, value: item.id })
        const childs = item.childs || []
        childs.forEach((child) => appendTalentOptions(child, temp_options, depth + 1))
    }

    useEffect(() => {
        loadTalents().then(talents => {
            if (talents) {
                const built_talents = BuildTalents(talents)
                const temp_options = []
                built_talents.forEach((item) => appendTalentOptions(item, temp_options, 0))
                setSelectOptions(temp_options)
            }
        })
    }, [])

    const handleSelect = (e) => {
        callback(e ? e.value : null, "talent")
    }

    return (
        <>
            <div className="filter-select">
                <Select
                    options={SelectOptions}
                    styles={customStyles}
                    onChange={handleSelect}
                    placeholder="Talents"
                    value={selectedOption}
                    isClearable
                />
            </div>

        </>
    )
}
